import { Base64 } from 'js-base64';
import { v4 as uuidv4 } from 'uuid';

const localStoragePrefix = 'vuoAnalyticsEntry-';

const createOrUpdateEntry = ({ key, values }) => {
  const itemKey = key || localStoragePrefix + uuidv4();
  const value = Base64.encode(JSON.stringify(values));
  try {
    localStorage.setItem(itemKey, value);
  } catch (err) {
    console.error(err);
  }
}

const findExistingEntry = ({ ...values }) => {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.indexOf(localStoragePrefix) === 0) {
        const entry = JSON.parse(Base64.decode(localStorage.getItem(key)));
        const valueKeys = Object.keys(values);
        const same = valueKeys.every(valueKey => {
          return entry[valueKey] === values[valueKey];
        });
        if (same) return {key: key, values: entry};
      }
    }
    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
}

const getKeys = () => {
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.indexOf(localStoragePrefix) === 0) {
      keys.push(key);
    }
  }
  return keys;
}

export default {
  createOrUpdateEntry,
  findExistingEntry,
  getKeys
};
